import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';
import { colorToHexCode, sizeToSvgWidth } from '../../utils';

export const HistoryA: FC<BaseSvgProps> = ({
  'data-testid': dataTestId,
  width = sizeToSvgWidth.sm,
  primaryColorHexCode = colorToHexCode.black,
}) => (
  <svg
    data-testid={dataTestId}
    width="14"
    height="27"
    className="shrink-0"
    viewBox="0 -0.5 14 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.813 13.5C11.813 10.7041 9.54643 8.4375 6.75049 8.4375V7.1875C10.2368 7.1875 13.063 10.0137 13.063 13.5C13.063 16.9863 10.2368 19.8125 6.75049 19.8125C3.26419 19.8125 0.437988 16.9863 0.437988 13.5H1.68799C1.68799 16.2959 3.95455 18.5625 6.75049 18.5625C9.54643 18.5625 11.813 16.2959 11.813 13.5Z"
      fill={primaryColorHexCode}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.71204 13.0029C1.69614 13.1662 1.68799 13.3321 1.68799 13.5L0.437988 13.5C0.437988 13.2916 0.44811 13.0853 0.467922 12.8818L1.71204 13.0029ZM2.2845 11.1136C2.12929 11.4033 2.00154 11.7098 1.90464 12.0297L0.708338 11.6672C0.829396 11.2677 0.988945 10.8849 1.1826 10.5234L2.2845 11.1136ZM3.53909 9.58624C3.28271 9.79688 3.04737 10.0322 2.83673 10.2886L1.87091 9.49507C2.13324 9.17579 2.42628 8.88275 2.74555 8.62043L3.53909 9.58624ZM5.28016 8.65415C4.96033 8.75105 4.65382 8.8788 4.36404 9.03401L3.77385 7.93211C4.13541 7.73846 4.51814 7.57891 4.91771 7.45785L5.28016 8.65415ZM6.75049 8.4375C6.58256 8.4375 6.41673 8.44565 6.25334 8.46156L6.13226 7.21743C6.33583 7.19762 6.54207 7.1875 6.75049 7.1875L6.75049 8.4375Z"
      fill={primaryColorHexCode}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.48853 14.4556L5.44165 14.4556L5.44165 10.4087L6.69165 10.4087L6.69165 13.2056L9.48853 13.2056L9.48853 14.4556Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
